<template>
  <div>
    <el-form
      style="width:500px"
      ref="searchForm"
      :rules="searchRules"
      :model="searchForm"
      label-width="120px"
      size="mini"
      labelPosition="right"
    >
      <el-form-item label="开始时间" prop="startTime">
        <el-col :span="16">
          <el-date-picker
            v-model="searchForm.startTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 100%"
            :picker-options="startDatePicker"
            type="date"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-col :span="16">
          <el-date-picker
            v-model="searchForm.endTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 100%"
            :picker-options="endDatePicker"
            type="date"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="startSearch('searchForm')"
          >确定</el-button
        >
        <el-button @click="cancleSearch">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        startTime: null,
        endTime: null
      },
      labelPosition: "left",
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      searchRules: {}
    };
  },

  methods: {
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.searchForm.endTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.searchForm.endTime).getTime() < time.getTime();
          } else {
            return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    processDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.searchForm.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.searchForm.startTime).getTime() > time.getTime()
            );
          } else {
            return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    startSearch(formName) {
      //所有参数是否为空    是的话 return false   否的话

      if (this.$baseFunc.paramsValidate(this.searchForm)) {
        this.$message({
          type: "error",
          message: "请选择检索参数"
        });
        return false;
      }

      console.log("this.searchForm", this.searchForm);
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            searchShow: false,
            searchData: this.searchForm
          };
          this.$emit("startSearch", obj);
        } else {
          return false;
        }
      });
    },
    cancleSearch() {
      let obj = {
        searchShow: false
      };
      this.$emit("cancleSearch", obj);
    },

    deleteSearchItem(e) {
      this.searchForm[e] = null;
    },
    addSearchItem(obj) {
      this.searchForm = { ...this.searchForm, ...obj };
    }
  },
  created() {}
};
</script>

<style></style>
